<template>
    <div id="header">
        <img id="logo" :src="siteLogo" alt="" onerror="this.style.display = 'none';"/>
    </div>
</template>

<script>
    import { mapState } from "vuex";

    export default {
        name: "Header",
       
        computed: {
            ...mapState({
                session: state => state.session
            }),
            siteLogo() {
                const siteId = this.session.siteId;
                const accountId = this.session.accountId;

                if (accountId !== undefined && siteId !== undefined) {
                    return "/site/sitelogo/" + siteId + "/" + accountId;
                }

                return undefined;
            }
        }
    }
</script>

<style scoped>
    #header {
        background-color: var(--darker-gray);
        display: flex;
        flex-direction: row;
        align-items: center;
        justify-content: center;
    }

    #logo {
        height: 50px;
    }
</style>